module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "ask-detail",
      "has-comments": _vm.hasComments,
      "detail": _vm.detail,
      "auto-open-app": false
    }
  }, [_c('div', {
    staticClass: "m-header"
  }, [_c('h2', {
    staticClass: "title f-taj"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [(_vm.showDomain) ? _c('span', [_vm._v(_vm._s(_vm.detail.domain))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "m-content"
  }, [_c('div', {
    staticClass: "item m-f-q"
  }, [_c('user-avatar', {
    attrs: {
      "avatar": _vm.fQ.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name f-toe1"
  }, [_vm._v(_vm._s(_vm.fQ.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "to f-cb"
  }, [_c('span', {
    staticClass: "f-fl f-toe1 name-a"
  }, [_c('span', {
    staticClass: "prefix"
  }, [_vm._v("向")]), _vm._v(_vm._s(_vm.detail.answer_user_name))]), _vm._v(" "), _c('span', {
    staticClass: "f-fl suffix"
  }, [_vm._v("提问")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.fQ.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('pre', {
    staticClass: "f-pre",
    domProps: {
      "innerHTML": _vm._s(_vm.fQ.content)
    }
  })])], 1), _vm._v(" "), (_vm.showFA) ? _c('div', {
    staticClass: "item m-f-a"
  }, [_c('user-avatar', {
    attrs: {
      "avatar": _vm.fA.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name f-toe1"
  }, [_vm._v(_vm._s(_vm.fA.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.fA.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('pre', {
    staticClass: "f-pre",
    domProps: {
      "innerHTML": _vm._s(_vm.fA.content)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showSQ) ? _c('div', {
    staticClass: "item m-s-q"
  }, [_c('user-avatar', {
    attrs: {
      "avatar": _vm.sQ.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name f-toe1"
  }, [_vm._v(_vm._s(_vm.sQ.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.sQ.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('pre', {
    staticClass: "f-pre",
    domProps: {
      "innerHTML": _vm._s(_vm.sQ.content)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showSA) ? _c('div', {
    staticClass: "item m-s-a"
  }, [_c('user-avatar', {
    attrs: {
      "avatar": _vm.sA.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name f-toe1"
  }, [_vm._v(_vm._s(_vm.sA.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("dateFormat1")(_vm.sA.date_timestamp, 'yyyy-MM-dd hh:mm')))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('pre', {
    staticClass: "f-pre",
    domProps: {
      "innerHTML": _vm._s(_vm.sA.content)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showStatus) ? _c('div', {
    staticClass: "m-status-bar"
  }, [_vm._v("\n\t\t\t问题状态"), _c('span', {
    class: ['status', 'status-' + _vm.statusCode]
  }, [_vm._v(_vm._s(_vm.statusText))])]) : _vm._e()]), _vm._v(" "), (_vm.showRelated) ? _c('div', {
    staticClass: "m-related"
  }, [_c('h4', {
    staticClass: "m-bt"
  }, [_c('span', {
    staticClass: "u-tt"
  }, [_vm._v("相关问题")])]), _vm._v(" "), _c('ul', _vm._l((_vm.related), function(item, index) {
    return _c('li', [_c('a', {
      class: ['ask-link', 'f-toe1', 'status-' + item.status],
      attrs: {
        "href": _vm._f("path")(item)
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('comment-normal', {
    attrs: {
      "comments": _vm.comments
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-531d858c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-ask-detail.vue
// module id = 852
// module chunks = 2